export const SOLANA_PAYLOAD_METHODS = {
  SIGN_TRANSACTION: 'sol_signTransaction',
  SIGN_MESSAGE: 'sol_signMessage',
  PARTIAL_SIGN_TRANSACTION: 'sol_partialSignTransaction',
} as const;
